import React, { createContext, useContext, type ReactNode } from "react";

const RfpIdContext = createContext<string | null>(null);

type RfpIdProviderProps = {
  rfpId: string;
  children: ReactNode;
};

export const RfpIdProvider = ({
  rfpId,
  children,
}: RfpIdProviderProps): React.JSX.Element => (
  <RfpIdContext.Provider value={rfpId}>{children}</RfpIdContext.Provider>
);

export const useRfpId = (): string => {
  const rfpId = useContext(RfpIdContext);
  if (rfpId === null) {
    throw new Error("useRfpId must be used within a RfpIdProvider");
  }
  return rfpId;
};
